import { ContentService } from '@blk/cwp-ng-framework';

import { MarketViewCells } from './market-views-util.interface';
import { MarketViewsConstants } from './market-views.constants';

export class MarketViewsUtil {
	public static getAllCellsDcr(contentService: ContentService): [string[], MarketViewCells[]] {
		const [assetClasses, assetClassNumberOfItems, headerNames] = this.getContentDrivenConfig(contentService);
		const tableBody = assetClasses.map((assetClass, index) => {
			return {
				header: this.getHeaderCells(assetClass, headerNames),
				body: this.getBodyCells(assetClass, assetClassNumberOfItems[index], headerNames)
			};
		});
		return [assetClasses, tableBody];
	}

	public static getContentDrivenConfig(contentService: ContentService): [string[], number[], string[]] {
		const assetClassesString: string = contentService.get('MARKET_MOVES_ASSET_CLASS_DCR_KEYS', '').replace(/\s/g, '');
		const assetClasses = assetClassesString
			? assetClassesString.split(',').map(asset => `MARKET_VIEWS_${asset.toUpperCase()}`)
			: MarketViewsConstants.MARKET_MOVES_ASSET_CLASS_DCR_KEYS;

		const assetClassNumberOfItemsString: string = contentService.get('MARKET_MOVES_ASSET_CLASS_ITEM_NUMBER', '').replace(/\s/g, '');
		const assetClassNumberOfItems = assetClassNumberOfItemsString
			? assetClassNumberOfItemsString.split(',').map(item => Number(item))
			: MarketViewsConstants.MARKET_MOVES_ASSET_CLASS_ITEM_NUMBER;

		return [assetClasses, assetClassNumberOfItems, MarketViewsConstants.MARKET_MOVES_HEADER_DCR_KEYS];
	}

	public static getBodyCells(assetClass: string, numberOfRow: number, headerNames: string[]): string[][] {
		const cells = [];
		for (let i = 0; i < numberOfRow; i++) {
			const row = [];
			headerNames.forEach(header => {
				const dcrKey = this.getDcrKey(assetClass, i, header);
				row.push(dcrKey);
			});
			cells.push(row);
		}
		return cells;
	}

	public static getHeaderCells(assetClass: string, headerNames: string[]): string[] {
		return headerNames.map(header => {
			return `${assetClass}_HEADER_${header}`;
		});
	}

	public static getDcrKey(assetClass: string, index: number, cellKey: string): string {
		return `${assetClass}_ROW${index}_${cellKey.toUpperCase()}`;
	}

	public static getDataFromConfig(defaultTranslationFromConfig: any): [string[], MarketViewCells[]] {
		const assetClasses = [];
		const allCells = [];
		let cellsInCurrentAsset: string[][] = [];
		defaultTranslationFromConfig.rows.forEach((row, index) => {
			if (row.isHeader) {
				assetClasses.push(row.view);
				if (cellsInCurrentAsset.length) {
					allCells.push(
						{
							header: defaultTranslationFromConfig.headers,
							body: cellsInCurrentAsset
						}
					);
					cellsInCurrentAsset = [];
				}
			} else {
				cellsInCurrentAsset.push(
					[row.view, row.assetClassName, row.description]
				);
				if (index === defaultTranslationFromConfig.rows.length - 1) {
					allCells.push(
						{
							header: defaultTranslationFromConfig.headers,
							body: cellsInCurrentAsset
						}
					);
				}
			}
		});

		return [assetClasses, allCells];
	}
}
